export default function Footer() {
  return (
    <div className="py-10 bg-violet-950 text-center text-white shadow-lg">
      &copy; Balaguru 2024
    </div>
  );
}
